import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";

import { selectAuth } from "../reducers/authSlice";
import Login from "../pages/login/Login";
import Inicio from "../pages/inicio/Inicio";
import Error from "../pages/error/Error";

///********* PAGINAS *************/
import CursosDisponibles from '../pages/alumno/cursos/CursosDisponibles'
import CursosInscriptos from '../pages/alumno/cursos/CursosInscriptos'
import CursosHistorial from '../pages/alumno/cursos/CursosHistorial'
import DatosPersonales from '../pages/alumno/DatosPersonales'


const PrivateRoute = ({ children, ...rest }) => {
  const auth = useSelector(selectAuth);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

const Body = () => {
  return (
    <>
      <Switch>
        {/* RUTAS PÚBLICAS */}
        <Route exact path="/login" component={Login} />

        <Route exact path="/publica">
          <p>Esta es una ruta pública</p>
        </Route>

        {/* RUTAS PRIVADAS */}
        <PrivateRoute exact path="/">          
          <Inicio />
        </PrivateRoute>        

        <PrivateRoute exact path="/alumno/datosPersonales">
            <DatosPersonales funcion="/alumno/datosPersonales"/>
        </PrivateRoute>

        <PrivateRoute exact path="/alumno/cursosDisponibles">
            <CursosDisponibles funcion="/alumno/cursosDisponibles"/>
        </PrivateRoute>
        
        <PrivateRoute exact path="/alumno/cursos/inscriptos">
            <CursosInscriptos funcion="/alumno/cursos/inscriptos"/>
        </PrivateRoute>    

        <PrivateRoute exact path="/alumno/cursos/historial">
            <CursosHistorial funcion="/alumno/cursos/historial"/>
        </PrivateRoute>             

        {/* RUTA DE ERROR */}
        <Route>
          <Error msg="Página no encontrada" />
        </Route>
      </Switch>
    </>
  );
};

export default Body;